export default {"src":"/_next/static/media/profile.cadcea29.svg","height":28,"width":26,"blurWidth":0,"blurHeight":0};